import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const Banner: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')(`
  color: #6B778C;
  font-size: 14px;
  font-weight: 400;
`);

export default Banner;